import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'clave',
      'empresa',
      'numero_de_poliza',
      'aseguradora',
      'fecha_de_colocacion',
      'fecha_de_renovacion',
      'fecha_de_vencimiento_de_seguro',
      'observaciones',
    ],
  },
];

const configs = {
  clave: {
    formItemProps: {
      label: 'Clave',
      required: true,
    },
  },
  empresa: {
    advanced: true,
    control: InputSearchPro,
    rules: [{ required: true }],
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
  numero_de_poliza: {
    formItemProps: {
      label: 'Número de Poliza Seguro',
    },
  },
  aseguradora: {
    formItemProps: {
      label: 'Aseguradora',
      required: true,
    },
  },
  fecha_de_colocacion: {
    formItemProps: {
      label: 'Fecha de Colocación',
      required: true,
    },
  },
  fecha_de_renovacion: {
    formItemProps: {
      label: 'Fecha de Renovación',
      required: true,
    },
  },
  fecha_de_vencimiento_de_seguro: {
    formItemProps: {
      label: 'Fecha de Vencimiento de Seguro',
      required: true,
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
